import React, { useMemo } from 'react';
import { Redirect } from 'expo-router';
import SignInScreen from '@/components/domain/auth/SignInScreen';
import { getCommunityFromDomain, type CommunityCode } from '@/constants/communities';
import { useRawSearchParam } from '@/hooks/useRawSearchParam';
import { useTranslation } from 'react-i18next';

export default function Auth() {
  const redirect = useRawSearchParam('redirect');
  const domainCommunity = useMemo(() => getCommunityFromDomain(), []);
  const community: CommunityCode | undefined = domainCommunity;
  const { t } = useTranslation();
  
  if (!community) return <Redirect href="/communities" />;

  return <SignInScreen title={t('auth.signIn.title')} community={community} redirect={redirect} />;
}
